import type {
  BreadcrumbLinkProps,
  BreadcrumbsProps,
} from '@/components/Breadcrumbs/types';
import type { CategoryHeader } from '@/utils/pages/api';
import { LIBRARY_ROOTS } from '@/constants/library-roots';
import { getBreadcrumbChildren } from './get-breadcrumb-children';
import { getBreadcrumbParents } from './get-breadcrumb-parents';
import { getCurrentBreadcrumb } from './get-current-breadcrumb';

export const SFX_BREADCRUMB_ROOT: BreadcrumbLinkProps = {
  id: '0',
  label: 'Sound effects',
  slug: 'sfx',
  relative_url: LIBRARY_ROOTS.SFX,
};

export const getSfxBreadcrumbs = ({
  pageData,
}: {
  pageData: CategoryHeader;
}): BreadcrumbsProps => {
  const current = getCurrentBreadcrumb({ data: pageData });

  const previous = [SFX_BREADCRUMB_ROOT];

  const canonicalParentsLinks = getBreadcrumbParents({
    data: pageData.breadcrumb_parents,
  });

  if (canonicalParentsLinks) {
    previous.push(...canonicalParentsLinks);
  }

  const result: BreadcrumbsProps = {
    current,
    previous,
    next: getBreadcrumbChildren({ taxonomy: pageData.taxonomy }),
    assetType: 'sfx',
  };

  return result;
};
